<template>
  <div class="slide">
    <Header align="center" center="1">
      Hvilken av disse passer for deg?
    </Header>
    <div class="grid-container genderSelection employmentSelection">
      <div class="grid-x">
        <div class="small-6 medium-3 colums text-center">
          <input
            v-model="employment"
            id="employmentStudent"
            name="employment"
            type="radio"
            value="student"
            class="ng-untouched ng-valid ng-dirty"
          /><label
            class="employmentSelection--student text-center"
            for="employmentStudent"
            ><span class="icon block m--center" :class="`${sex}-student`"></span
            ><span>Student</span></label
          >
        </div>
        <div class="small-6 medium-3 colums text-center">
          <input
            v-model="employment"
            id="employmentWorker"
            name="employment"
            type="radio"
            value="worker"
            class="ng-untouched ng-valid ng-dirty"
          /><label
            class="employmentSelection--worker text-center"
            for="employmentWorker"
            ><span class="icon block m--center" :class="`${sex}-worker`"></span
            ><span>Jobber</span></label
          >
        </div>
        <div class="small-6 medium-3 colums text-center ">
          <input
            v-model="employment"
            id="employmentRetired"
            name="employment"
            type="radio"
            value="retired"
            class="ng-untouched ng-valid ng-dirty"
          /><label
            class="employmentSelection--retired text-center"
            for="employmentRetired"
            ><span class="icon block m--center" :class="`${sex}-retired`"></span
            ><span>Pensjonist</span></label
          >
        </div>
        <div class="small-6 medium-3  colums text-center">
          <input
            v-model="employment"
            id="employmentOther"
            name="employment"
            type="radio"
            value="other"
            class="ng-untouched ng-valid ng-dirty"
          /><label
            class="employmentSelection--other text-center"
            for="employmentOther"
            ><span class="icon block m--center" :class="`${sex}-other`"></span
            ><span>Annet</span></label
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../common/Header";

export default {
  components: {
    Header: Header,
  },
  computed: {
    sex: {
      get() {
        return this.$store.state.sex;
      },
    },
    student() {
      return this.sex + "-student";
    },
    employment: {
      get() {
        if (this.$store.state.employment == "") {
          this.$eventBus.$emit("allowNext", false);
        } else {
          this.$eventBus.$emit("allowNext", true);
        }

        return this.$store.state.employment;
      },
      set(value) {
        this.$store.commit("setEmployment", { employment: value });
      },
    },
  },
};
</script>
